















































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import {
  RepairOrderListViewModel,
  AddAttachmentModel,
  AttachmentInfoViewModel,
  RoEmailViewModel,
  RepairOrderCustomerInfoViewModel,
  CallType,
  RepairOrderViewModel,
} from '@/models/fixedops/repairorder';
import { MetadataType } from '@/enums/enums';
import { RepairOrderPagedListModel } from '@/models/pagedlistmodel';
import { RepairOrderService } from '@/services/fixedOps/repairorder.service';
import { CustomerService } from '@/services/accounting/customer.service';
import { VoiceCallService } from '@/services/telephony/voicecall.service';
import { CallTypeService } from '@/services/admin/calltype.service';
import { Base } from '../common/base';
import { attachmentTypeService, repairOrderService } from '@/shared';
import { IDialogOption } from '@/models/dialog';
import { PaymentTypeDialog, RoleType } from '@/helper/enum';
import { Utils } from '../../helper/utils';

@Component({
  props: [
    'pagedRepairOrders',
    'paymentProvider',
    'pagination',
    'gridLoading',
    'methodName',
    'progress',
  ],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    paginations: {
      get() {
        return this.$props.pagination;
      },
      set(val) {
        this.$emit('paging', val);
      },
    },
    loading: {
      get() {
        return this.$props.gridLoading;
      },
    },
    buttonType: {
      get() {
        if (this.email.customer && this.email.self) {
          return 'both';
        } else {
          if (this.email.customer) {
            return 'customer';
          } else {
            return 'self';
          }
        }
      },
    },
  },
  components: {
    AttachmentForm: () => import('./repairorder.attachment.add.vue'),
    Grid: () => import('@/components/common/app.grid.vue'),
    CustomerInformation: () => import('./customer.information.vue'),
    VoiceConversation: () => import('./voice.conversation.vue'),
    EmailSend: () => import('./email.send.vue'),
    SnackBarLoader: () => import('@/components/common/loader.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class OpenRepairOrderListComponent extends Base {
  // public loading: boolean = false;
  public paginations: any;
  public pagedRepairOrders: RepairOrderPagedListModel<RepairOrderListViewModel>;
  public videoLynkPagination = new PaginationModel('date', true);
  public videoLynkAttachments: any[] = [];

  public roNumber: string = '';
  public methodName: string = '';
  public childProgress: boolean = false;
  public roDetailLoader: boolean = false;
  public paymentloading: boolean = false;
  public amountToBePaid: string = '0.00';
  public isSendPaymentReceipt: boolean = true;
  public paymentProvider: string = '';
  public videoLoading: boolean = false;
  public isBypassCreditCardFeeRole: boolean = false;
  public isOverrideCCFeeApplied: boolean = true;
  public bypassReason: string = '';

  public flags: any = {
    showForm: false,
    showEmailPopup: false,
    showCustomerInfo: false,
    showCallPopup: false,
  };

  public constants: any = {
    roNumber: '',
    laneId: 0,
    cardId: '',
  };

  public videoLynk: any = {
    email: '',
    phone: '',
  };

  public payment: any = {
    amountToBePaid: '',
    paymentMode: '',
    amountPaid: '',
    paymentType: '',
  };

  public healthApproval: any = {
    sendMode: '',
  };

  public approvalRequest: any = {
    isApproved: false,
    id: ''
  };

  public paymentAmountDialog: IDialogOption = {
    width: 450,
    title: this.$parent.$t(
      'repairOrderDetails.paymentAmountDialog.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-money-bill',
      text: this.$parent.$t(
        'repairOrderDetails.paymentAmountDialog.btnPay'
      ) as string,
    },
    onAction: (): void => {
      this.confirmPaymentDialog();
    },
  };

  public approveConfirmationDialog: IDialogOption = {
    width: 450,
    title: 'Confirm And Send',
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: 'Confirm',
      disable: false
    },
    onAction: (): void => {
      if (this.healthApproval.sendMode == '') {
        this.showAlert(false, 'Please Select One of the type to send Video');
        return;
      }
      this.approveAttachment();
    },
  };



  public confirmPaymentDialog() {
    if (this.validateForm()) {
      let amount = '0.00';
      // get amountToBePaid
      if (this.payment.paymentMode === 'full') {
        amount = this.roDetails.displayDueAmount;
      } else if (this.payment.paymentMode === 'partial') {
        amount = this.payment.amountPaid;
      } else {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertPleaseSelectOnePaymentType')
        );
        return;
      }

      if (Number(amount) < 0) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertAmountShouldBeGreater')
        );
        return;
      }

      if (!amount && Number(amount) <= 0) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertAmountShouldGreaterThanZeroAndValid')
        );
        return;
      }

      if (Number(amount) > Number(this.roDetails.displayDueAmount)) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertAmountShouldLessThanTotalDue')
        );
        return;
      }

      if (!this.isOverrideCCFeeApplied && this.bypassReason == "") {
        this.showAlert(false, 'The Bypass Reason field is required');
        return;
      }

      this.paymentAmountDialog.model = false;
      this.amountToBePaid = amount;
      // show modal popup

      this.payWithCardOnFile();

      this.payment.paymentMode = '';
    }
  }

  public headers: VHeaders[] = [
    {
      align: 'left',
      text: '',
      sortable: false,
      value: ' ',
      fieldType: 'template',
      template: (item) => {
        let html = '';
        if (item.unreadMessageCount) {
          html =
            html +
            `<v-badge overlap color="orange">
                                <span slot="badge">${item.unreadMessageCount}</span>
                                <v-icon dark color="primary">fas fa-comment</v-icon>
                            </v-badge>`;
        }

        if (item.videoClipDetails && item.videoClipDetails.totalCount > 0) {
          if (item.videoClipDetails.approved == item.videoClipDetails.totalCount) {
            html =
              html +
              `<v-icon color="green">
                                    fas fa-video
                                </v-icon>`;
          } else {
            html = html +
              `<v-icon color="yellow">
                                    fas fa-video
                                </v-icon>`;
          }
        }
        return html;
      },
      onClick: (item) => {
        if (item.videoClipDetails && item.videoClipDetails.totalCount > 0) {
          this.getCustomerDetail(item.customerKey);
          this.getAttachments(item);
        }
      }
    },
    // {
    //   text: '',
    //   align: 'left',
    //   value: '',
    //   sortable: false,
    //   fieldType: 'icon',
    //   icon: { class: 'fas fa-video', color: 'primary' },
    //   visible: (item) => {
    //     return item.isVideoClipSubmitted;
    //   },
    //   onClick: (item, e) => {
    //     this.getAttachments(item);
    //     this.getCustomerDetail(item.customerKey);
    //   },
    // },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('openRo.openRepairOrderGrid.status') as string,
      value: `status`,
      fieldType: 'template',
      template: (item) => {
        if (item.payment) {
          return `<span>
                                <v-icon color="${item.isPaymentApproved ? 'green' : 'orange'
            }">
                                    fas fa-dollar-sign
                                </v-icon>
                                <span style="color: ${item.isPaymentApproved ? '#388E3C' : '#F57C00'
            };">
                                    ${item.status || 'N/A'}
                                </span>
                            </span>`;
        } else {
          return `<span>${item.status || 'N/A'}</span>`;
        }
      },
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('openRo.openRepairOrderGrid.ro') as string,
      value: 'repairOrderNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('openRo.openRepairOrderGrid.customer') as string,
      value: 'customerName',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('openRo.openRepairOrderGrid.lastVin') as string,
      value: 'vin',
      filters: [
        (val, item) => {
          return item.vin && item.vin.length > 10
            ? item.vin.substring(item.vin.length - 8, item.vin.length)
            : item.vin || 'N/A';
        },
      ],
    },
    {
      align: 'left',
      sortable: false,
      text: this.$parent.$t('openRo.openRepairOrderGrid.svcWriter') as string,
      value: `serviceWriterName`,
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('openRo.openRepairOrderGrid.tag') as string,
      value: `tagNumber`,
    },
    {
      align: 'center',
      isNotDataProp: true,
      sortable: false,
      text: 'Action',
    },
  ];

  public videolynkHeaders: VHeaders[] = [
    {
      align: 'left',
      text: 'DateTime',
      sortable: false,
      value: `createdDateTime`,
      fieldType: 'date',
    },
    {
      align: 'left',
      text: 'User',
      sortable: false,
      value: `userName`,
    },
    {
      align: 'left',
      text: 'Status',
      sortable: false,
      value: `isApprovalRequired`,
      filters: [
        (val, item) => {
          if (item.isApprovalRequired)
            return 'Pending';
          else {
            if (item.isApproved) {
              return 'Approved';
            } else {
              return 'Rejected';
            }
          }
        },
      ],
    },
    {
      align: 'center',
      isNotDataProp: true,
      sortable: false,
      text: 'Action',
    }
  ];

  public actions: any[] = [];
  public videoActions: any[] = [];

  public calling;
  public buttonType;

  public email: any = {
    self: false,
    customer: false,
    from: '',
    froms: [],
  };

  public callTypes: CallType[] = [];
  public callInfo: any = {
    callType: '',
    callTo: '',
    otherNumber: '',
    repairOrderNumber: '',
  };

  public customerModel: RepairOrderCustomerInfoViewModel = {};
  public emailSendModel: RepairOrderCustomerInfoViewModel = {};
  public callModel: RepairOrderCustomerInfoViewModel = {};

  public addAttachmentTypeModel: AddAttachmentModel = {};
  public attachmentDetails: AttachmentInfoViewModel[] = [];
  public customerInfo: RepairOrderCustomerInfoViewModel = {};
  public emailModel: RoEmailViewModel = { storeId: 0, storeName: '' };
  public roService: RepairOrderService;
  public customerService: CustomerService;
  public voiceCallService: VoiceCallService;
  public callTypeService: CallTypeService;
  public roDetails: RepairOrderViewModel = {};
  public fileOnCardsList: any[] = [];
  public lstCustomerEmails: string[] = [];
  public lstCustomerPhone: string[] = [];


  public customerPhoneNumber(): string {
    let pNumber = '';
    switch (this.callInfo.callTo) {
      case 'home': {
        pNumber = this.customerInfo.phoneNumber;
        break;
      }
      case 'cellphone': {
        pNumber = this.customerInfo.cellPhone;
        break;
      }
      case 'businessPhone': {
        pNumber = this.customerInfo.businessPhone;
        break;
      }
      case 'other': {
        pNumber = this.callInfo.otherNumber;
        break;
      }
      default: {
        pNumber = this.customerInfo.phoneNumber;
      }
    }
    return pNumber;
  }
  public updateToolBar(additionalButtons): void {
    let buttons: any = [];
    if (additionalButtons) {
      buttons = buttons.concat(additionalButtons);
    }
    this.$emit('updateChildToolBar', buttons);
  }
  public updateChildToolBar(buttons): void {
    if (this.flags.showForm) {
      this.updateToolBar(buttons);
    }
  }
  public resetMethodName(methodName): void {
    this.$emit('resetMethodName', methodName);
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateChildToolBar', buttons);
  }
  public callMethod(methodName): void {
    //
  }

  public mounted(): void {
    this.roService = new RepairOrderService();
    this.customerService = new CustomerService();
    this.voiceCallService = new VoiceCallService();
    this.callTypeService = new CallTypeService();

    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.methodName = newVal;
        this.callMethod(newVal);
      }
    });
    this.$watch('flags.showForm', (newVal, oldVal) => {
      if (newVal === false) {
        this.updateToolBar(null);
      }
    });
    this.$watch('childProgress', (newVal, oldVal) => {
      this.$emit('update:childProgress', newVal);
    });
    this.$watch('paymentProvider', (newVal, oldVal) => {
      this.setActions();
    });
    this.paymentProvider = this.$props.paymentProvider;
    this.setActions();
    var role = [RoleType.BypassCreditCardFee.toString()];
    var isRoleAllowed = this.userSession.roles.filter(x => role.includes(x));
    this.isBypassCreditCardFeeRole = isRoleAllowed.includes(role[0]);

  }

  public viewAttachment(model: RepairOrderListViewModel): void {
    this.roNumber = model.repairOrderNumber;
    if (this.roNumber) {
      this.flags.showForm = true;
      this.$emit('updateFlag', 'showForm', true);
    } else {
      this.showAlert(false, 'RO not found');
      return;
    }
  }

  public selectCardPopup: IDialogOption = {
    width: 400,
    title: 'Select Card',
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-money-bill',
      text: 'Pay',
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.makeFileOnCardsPayment();
    },
  };

  public videolynkPopup: IDialogOption = {
    width: 700,
    title: 'Approve/Reject RO Video',
    model: false,
    loading: false,
    // onClose: (): void => {
    //   this.closevideoPopup();
    // },
  };

  // public closevideoPopup() {
  //   this.videolynkPopup.loading = false;
  //   this.videolynkPopup.model = false;
  // }

  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-dollar-sign',
        title: 'Pay with Card on file',
        color: 'green',
        visible: (model: RepairOrderListViewModel) => {
          if ((this.$props.paymentProvider == 'Square' || this.$props.paymentProvider == 'Clover' || this.$props.paymentProvider == 'Payroc') && model.isCardExists) {
            return true;
          } else {
            return false;
          }
        },
        action: (model: RepairOrderListViewModel) => {
          this.getOrderDetail(model);
        },
      },
      {
        type: 'link',
        icon: 'fas fa-ticket-alt',
        title: 'Receipts',
        visible: (model: RepairOrderListViewModel) => {
          if (this.$props.paymentProvider == 'Square') {
            return true;
          }
          return false;
        },
        action: (model: RepairOrderListViewModel) => {
          return {
            name: 'app.repairorders.receipts',
            params: {
              roNumber: model.repairOrderNumber,
              vin: model.vin,
            },
          };
        },
      },
      // RO DETAIL
      {
        type: 'link',
        icon: 'fa fa-eye',
        title: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.view'
        ) as string,
        visible: (model: RepairOrderListViewModel) => {
          return model.repairOrderNumber;
        },
        action: (model: RepairOrderListViewModel) => {
          return {
            name: 'app.repairorders.detail',
            params: {
              roNumber: model.repairOrderNumber,
            },
            query: {
              sType: 'n',
            },
          };
        },
      },
      // SEND EMAIL
      {
        type: 'button',
        icon: 'fa fa-envelope',
        title: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.sendEmail'
        ) as string,
        visible: (model) => {
          return this.pagedRepairOrders.isAdvisorRole;
        },
        action: (model: RepairOrderListViewModel) => {
          this.emailSendModel = model;
          this.flags.showEmailPopup = true;
        },
      },
      // CUSTOMER INFORMATION
      {
        type: 'button',
        icon: 'fa fa-user',
        title: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.customerInformation'
        ) as string,
        visible: (model: RepairOrderListViewModel) => {
          return model.customerKey && model.customerKey !== '0';
        },
        action: (model: RepairOrderListViewModel) => {
          this.customerModel = model;
          this.flags.showCustomerInfo = true;
        },
      },
      // VIEW ATTACHMENTS
      {
        type: 'button',
        icon: 'fa fa-paperclip',
        title: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.viewAttachments'
        ) as string,
        visible: (model: RepairOrderListViewModel) => {
          return true;
        },
        action: (model: RepairOrderListViewModel, storeid: string) => {
          this.viewAttachment(model);
        },
      },
      // SEND MESSAGE
      {
        type: 'link',
        icon: 'fas fa-comment',
        title: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.sendMessage'
        ) as string,
        visible: (model: RepairOrderListViewModel) => {
          return (
            model.customerKey !== '0' &&
            model.customerKey &&
            this.pagedRepairOrders.isMessagingEnabled &&
            this.pagedRepairOrders.isAdvisorRole &&
            this.isFeatureToAccess('MESSAGING')
          );
        },
        action: (model: RepairOrderListViewModel) => {
          return {
            name: 'advisor.conversation.add',
            params: {
              type: MetadataType[MetadataType.RO],
            },
            query: {
              recordKey: model.repairOrderNumber,
              customerKey: model.customerKey,
              vin: model.vin,
              sType: 'n',
              repairOrder: 'openRepairOrder'
            },
          };
        },
      },
      // CALL CUSTOMER
      {
        type: 'button',
        icon: 'fa fa-phone',
        title: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.callCustomer'
        ) as string,
        visible: (model: RepairOrderListViewModel) => {
          return (
            model.customerKey !== '0' &&
            model.customerKey &&
            this.pagedRepairOrders.isMessagingEnabled &&
            this.pagedRepairOrders.isAdvisorRole &&
            this.isFeatureToAccess('MESSAGING')
          );
        },
        action: (model: RepairOrderListViewModel) => {
          this.callModel = model;
          this.flags.showCallPopup = true;
        },
      },
      {
        type: 'button',
        icon: 'fas fa-video',
        title: 'Approve/Reject Videos',
        visible: (model: any) => {
          if (model.videoClipDetails && model.videoClipDetails.totalCount > 0) {
            return true;
          }
          return false;
        },
        action: (model: any) => {
          this.getAttachments(model);
          this.getCustomerDetail(model.customerKey);
        },
      },
    ];
  }

  public setVideoActions() {
    this.videoActions = [
      {
        type: 'button',
        icon: 'fas fa-check',
        title: 'Approve',
        color: 'green',
        visible: (model: any) => {
          if (model.isApprovalRequired) {
            return true;
          }
          return false;
        },
        action: (model: any, action: any) => {
          this.approveConfirmationDialog.model = true;
          this.approvalRequest.id = model.id;
          this.approvalRequest.isApproved = true;
        }
      },
      {
        type: 'button',
        icon: 'fas fa-ban',
        title: 'Reject',
        visible: (model: any) => {
          if (model.isApprovalRequired) {
            return true;
          }
          return false;
        },
        action: (model: any, action: any) => {
          // // this.approveAttachment(model, false);
          // this.approveConfirmationDialog.model = true;
          // this.approvalRequest.id = model.id;
          // this.approvalRequest.isApproved = false;
          this.rejectAttachment(model.id);
        }
      },
      {
        type: 'button',
        icon: 'fas fa-eye',
        title: 'View',
        action: (model: any, action: any) => {
          var uniqueId = Utils.newGuid();
          window.open(`${window.location.origin}/app/video/view/${uniqueId}/${model.attachmentExternalId}`);
          //alert(model.id + ' View Video');
          //this.approveAttachment(model, false);
        }
      }];
  }



  public newMessage(model): void {
    this.$router.push({
      name: 'advisor.conversation.add',
      query: {
        repairOrderNumber: model.repairOrderNumber,
        customerPhoneNumber: model.customerPhoneNumber,
        customerName: model.customerName,
        customerKey: model.customerKey,
      },
    });
  }

  public updateFlag(flag, value): void {
    this.flags[flag] = value;
    this.$emit('updateFlag', flag, value);
  }

  public updatePaging(paging: any): void {
    this.paginations = paging;
  }

  public async rejectAttachment(attachmentId: string): Promise<void> {
    try {
      await repairOrderService.rejectVideoClip(attachmentId);
      this.showAlert(true, 'Attachment Status Updated Successfully');
    } finally {

    }
  }


  public async approveAttachment(): Promise<void> {
    try {
      this.approveConfirmationDialog.loading = true;
      this.approveConfirmationDialog.action.disable = true;
      if (this.healthApproval.sendMode == 'Email') {
        if (this.videoLynk.email == '') {
          this.showAlert(false, 'Please Select Email.');
          return;
        }
        await repairOrderService.approveAndSendVideoClipEmail(this.approvalRequest.isApproved, this.approvalRequest.id, this.videoLynk.email);
      } else if (this.healthApproval.sendMode == 'Sms') {
        if (this.videoLynk.phone == '') {
          this.showAlert(false, 'Please Select Phone number.');
          return;
        }
        await repairOrderService.approveAndSendVideoClipSms(this.approvalRequest.isApproved, this.approvalRequest.id, this.videoLynk.phone);
      }
      this.showAlert(true, 'Approved Successfully');
    } finally {
      this.approvalRequest.id = '';
      this.approvalRequest.isApproved = false;

      this.approveConfirmationDialog.loading = false;
      this.approveConfirmationDialog.action.disable = false;
      this.approveConfirmationDialog.model = false;
      this.healthApproval.sendMode = '';
      this.videoLynk.email = '';
      this.videoLynk.phone = '';
    }
  }


  public async getCustomerDetail(customerKey): Promise<void> {
    try {
      var response = await repairOrderService.getCustomerDetails(customerKey);
      this.lstCustomerEmails = response.customerEmail;
      this.lstCustomerPhone = response.customerPhone;
    } finally { }
  }


  public async getOrderDetail(roModel): Promise<void> {
    try {
      // this.roDetailLoading = true;
      // this.loading = true;
      // this.paymentloading = true;
      this.roDetailLoader = true;
      const response = await repairOrderService.getRepairOrderPaymentDetails(
        roModel.repairOrderNumber
      );
      this.roDetails = response;
      this.fileOnCardsList = response.cards;
      if (
        this.roDetails.paymentDetail &&
        this.roDetails.paymentDetail.paymentResponses
      ) {
        this.roDetails.paymentDetail.paymentResponses.forEach((resp) => {
          resp.customerName = this.roDetails.customerName;
          resp.roNumber = this.roDetails.roNumber;
        });

        if (
          this.roDetails.paymentDetail &&
          this.roDetails.paymentDetail.paymentResponses &&
          this.roDetails.paymentDetail.paymentResponses.length > 0
        ) {
          if (this.roDetails.paymentDetail.status === 'Approved') {
            // this.flags.paymentApproved = true;
            this.showAlert(true, 'Payment Already Approved');
            return;
          }
        }

        if (
          Number(this.roDetails.displayDueAmount) <= 0 ||
          Number(this.roDetails.displayDueAmount) == NaN
        ) {
          this.showAlert(
            false,
            this.$t('repairOrderDetails.alertDueAmountMustGreaterThanZero')
          );
          return;
        }
      }

      this.payment.paymentType = '';
      this.payment.amountPaid = '';
      this.paymentAmountDialog.model = true;
      this.payment.paymentType = PaymentTypeDialog.cardOnFile;
    } finally {
      this.roDetailLoader = false;
    }
  }

  public fixDecimalValue(value) {
    if (this.payment.amountPaid) {
      const amount = Number(this.payment.amountPaid);
      const val = amount.toFixed(2);
      this.payment.amountPaid = val;
    } else {
      this.payment.amountPaid = undefined;
    }
  }

  public payWithCardOnFile(): void {
    if (
      Number(this.amountToBePaid) === 0 ||
      isNaN(Number(this.amountToBePaid))
    ) {
      this.showAlert(false, this.$t('repairOrderDetails.alertDueAmountIsZero'));
      return;
    }

    if (Number(this.amountToBePaid) < 0) {
      this.showAlert(false, 'Amount Should be greater than 0');
      return;
    }

    this.selectCardPopup.model = true;
  }

  // public async findCards(): Promise<void> {
  //   this.selectCardPopup.model = true;
  // }

  public async makeFileOnCardsPayment(): Promise<void> {
    const amount = this.roDetails.displayDueAmount;
    try {
      this.selectCardPopup.action.disable = true;
      this.selectCardPopup.loading = true;
      if (
        Number(this.amountToBePaid) === 0 ||
        isNaN(Number(this.amountToBePaid))
      ) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertDueAmountIsZero')
        );
        return;
      }

      if (Number(this.amountToBePaid) < 0) {
        this.showAlert(false, 'Amount Should be greater than 0');
        return;
      }

      if (!this.constants.cardId) {
        this.showAlert(false, 'Please select Card');
        this.selectCardPopup.action.disable = false;
        this.selectCardPopup.loading = false;
        return;
      }
      this.roDetails.displayDueAmount = this.amountToBePaid;
      this.roDetails.recordIdentifier = 'RO';
      this.roDetails.isSendPaymentReceipt = this.isSendPaymentReceipt;
      const response = await repairOrderService.makeCardOnFilePayment(
        this.roDetails,
        this.constants.cardId,
        this.isOverrideCCFeeApplied,
        this.bypassReason
      );
      this.roDetails.displayDueAmount = amount;

      if (response.isSuccess) {
        this.showAlert(true, response.responseMessage);
        if (response.recieptUrl != null) {
          window.open(response.recieptUrl, '_blank');
        }
      } else {
        this.showAlert(false, 'fail to make payment');
      }
    } catch {
      this.roDetails.displayDueAmount = amount;
    } finally {
      this.selectCardPopup.action.disable = false;
      this.selectCardPopup.model = false;
      this.selectCardPopup.loading = false;
      this.bypassReason = "";
    }
  }

  public async getAttachments(roDetails): Promise<void> {
    try {
      this.videolynkPopup.loading = true;
      this.videolynkPopup.model = true;
      this.videoLoading = true;

      const response = await repairOrderService.getAttachmentDetails(
        roDetails.repairOrderNumber,
        roDetails.vin
      );

      if (response.results) {
        this.videoLynkAttachments = response.results.
          filter(x => x.attachmentTypeName == 'Messaging Media' && x.attachmentUri.includes('VideoClip') && x.recordIdentifier == 'RO');
      }
    } finally {
      this.videoLoading = false;
      this.setVideoActions();
    }
  }
}
